/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { PDF_ACTIONS, EVENT_NAMES } from "constants/enums";
import { performPdfActions } from "pdfActionManager";
import { PageOpenEvent, PageCloseEvent } from "jsEvents/pageEvents";
import { logJSActionsBusyLoopData } from "javascript/loggingUtils";

const getEventObj = mode => {
  switch (mode) {
    case EVENT_NAMES.OPEN:
      return new PageOpenEvent();
    case EVENT_NAMES.CLOSE:
      return new PageCloseEvent();
    default:
      return {};
  }
};

export const executePageActions = ({ stores, actions = [], mode }) => {
  for (const action of actions) {
    if (action.actionType === PDF_ACTIONS.JAVASCRIPT) {
      performPdfActions(stores, [action], { eventObj: getEventObj(mode) });
      if (mode === EVENT_NAMES.OPEN) {
        logJSActionsBusyLoopData("pageOpen");
      }
    } else {
      performPdfActions(stores, [action], {});
    }
  }
};
